import React, { useState } from "react"
import styled, { css } from "styled-components"

import Icon from "../global/icon"

const size = {
  tablet: 950,
  mobile: 600,
  xs: 370,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.button`
  border: none;
  background-color: transparent;
  flex: 0 0 33.33333%;
  cursor: pointer;
  margin: 0 0 72px;
  padding: 0;
  ${below.tablet`margin-bottom: 64px; flex: 0 0 50%;`}
  ${below.mobile`padding: 0; margin-bottom: 16px; width: 100%;`}

  div {
    margin: 0 auto;
  }
  .card-name {
    font-weight: 600;

    text-align: center;
    margin-bottom: 8px;
    ${below.mobile`
    text-align: left;
    margin-bottom: 0px;
    `}
  }
  .license {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 8px;
    ${below.mobile`
    text-align: left;
    margin-bottom: 0px;
    `}
  }

  .card-title {
    font-family: "Playfair Display", serif;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    color: var(--grey);
    ${below.mobile`
    text-align: left; 
    padding-bottom: 8px;
    border-bottom: 1px solid #E2E8F0;
    `}
  }
  img {
    width: 240px;
    border-radius: 50%;
    margin: 0 0 40px;
    padding: 0;
    ${below.mobile`display: none;`}
  }
`
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: hsla(0, 0%, 0%, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`
const ModalCard = styled.div`
  background-color: white;
  border-radius: 8px;
  margin: 0 15px;
  padding: 0px 48px;
  max-width: 800px;
  position: relative;
  box-shadow: 0px 4.8412px 29.0472px rgba(19, 101, 186, 0.15);
  ${below.mobile`
padding: 0 24px;
`}
  p {
    ${below.xs`
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0px;
    `}
  }

  img {
    display: block;
    width: 200px;
    border-radius: 50%;
    ${below.tablet`width: 96px;`}
  }

  .modal-name {
    color: black;
    font-weight: 600;
    margin-bottom: 0;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.02em;
  }
  .modal-title {
    /* font-family: "Playfair Display"; */
    font-size: 22px;
    line-height: 28px;
    color: var(--pacific-blue);
    font-weight: 400;
    ${below.tablet`font-size: 18px; line-height: 24px;`}
    ${below.mobile`font-size: 12px; line-height: 16px;`}
  }
  .modal-license {
    color: var(--grey);
    font-size: 20px;
    line-height: 28px;
    ${below.tablet`font-size: 18px; line-height: 24px;`}
    ${below.mobile`font-size: 12px; line-height: 16px;`}
  }
  .header {
    transform: translateY(-52px);
    display: flex;
    justify-content: center;
    align-items: center;
    ${below.mobile`transform: translateY(0);`}

    .header-content {
      padding-left: 36px;
      margin-top: 50px;
      ${below.mobile`margin: 24px 0 32px;`}
    }
  }
`
const IconWrapper = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  margin: 0 auto;
  display: block;
  padding: 24px 24px 32px;
  svg {
    width: 16px;
    height: 16px;
    stroke-width: 4px;
    stroke: #000000;
  }
`

const LeadershipCard = props => {
  const [isToggled, setToggle] = useState(false)
  return (
    <>
      <Wrapper onClick={() => setToggle(!isToggled)}>
        <div>
          <img src={props.headshot} alt={props.name} />
          <h4 className="card-name sans">{props.name}</h4>
          {props.license && <div className="license">{`${props.license}`}</div>}
          <div className="card-title">{props.title}</div>
        </div>
      </Wrapper>
      {isToggled && (
        <ModalWrapper
          onClick={event => {
            event.stopPropagation()
            setToggle(false)
          }}
        >
          <ModalCard onClick={event => event.stopPropagation()}>
            <div className="header">
              <img src={props.headshot} alt={props.name} />
              <div className="header-content">
                <p className="modal-name sans">{props.name}</p>
                {props.license && (
                  <div className="modal-license">{`${props.license}`}</div>
                )}
                <div className="modal-title">{props.title}</div>
              </div>
            </div>

            <p>{props.bio}</p>
            <IconWrapper onClick={() => setToggle(!isToggled)}>
              <Icon icon="close-modal" />
            </IconWrapper>
          </ModalCard>
        </ModalWrapper>
      )}
    </>
  )
}

export default LeadershipCard
